import locale from 'uiv/src/locale/lang/en-US';

const locales = {
  ...locale.uiv,
  multiSelect: {
    placeholder: 'Select an item',
    filterPlaceholder: 'Search for an item',
  },
  datePicker: {
    ...locale.uiv.datePicker,
    week1: 'Mon',
    week2: 'Tue',
    week3: 'Wed',
    week4: 'Thu',
    week5: 'Fri',
    week6: 'Sat',
    week7: 'Sun',
  },
  modal: {
    ok: 'Yes',
    cancel: 'No, cancel',
  },
};

export default {
  uiv: {
    ...locales,
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/uiv.js